import { useSession } from "hooks/useSession";
import React from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
export default function DeleteModal({ id, title, message, apiUrl, onSuccess, deleteid,deleteKey }) {
  
const {userid} = useSession();
  const handleDelete = async () => {
    debugger;
    const formData = new FormData();
    
    formData.append("id", deleteid);
    formData.append("userid", userid);
    formData.append("action", "DELETE");
    formData.append(deleteKey, deleteid);

    // formData.append("id", "");

    try {
      const response = await fetchWrapper(apiUrl, {
        method: "POST",
        body: formData,
      });
      const result =response;

      if (result.status) {
        showMainToast(result.data || "Deleted successfully!", "success");
        if (onSuccess) onSuccess(); // refresh list, etc.

        // Close modal programmatically
        const modalEl = document.getElementById(id);
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal.hide();
      } else {
        showMainToast(result.data || "Failed to delete", "danger");
      }
    } catch (error) {
      console.error(error);
      showMainToast("Server error, please try again later", "danger");
    }
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-danger">
            <h5 className="modal-title text-white">{title || "Confirm Delete"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <h5 className="text-danger">
              {message || "Are you sure you want to delete this item?"}
            </h5>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" type="button" onClick={handleDelete}>
              Delete
            </button>
            <button
              className="btn btn-light-secondary"
              data-bs-dismiss="modal"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
